var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClutch1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "119px",
    height: "54px",
    viewBox: "0 0 119 54",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Clutch") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "10.864 16.297 4.478 19.654 5.698 12.543 0.532 7.507 7.671 6.47 10.864 0 14.057 6.47 21.197 7.507 16.031 12.543 17.25 19.654"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clutch-Homepage-Updates",
    transform: "translate(-254.000000, -737.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clutch",
    transform: "translate(254.000000, 737.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.864,16.297 L4.478,19.654 L5.698,12.543 L0.532,7.507 L7.671,6.47 L10.864,0 L14.057,6.47 L21.197,7.507 L16.031,12.543 L17.25,19.654 L10.864,16.297 Z M35.201,16.297 L28.815,19.654 L30.034,12.543 L24.868,7.507 L32.008,6.47 L35.201,0 L38.394,6.47 L45.533,7.507 L40.367,12.543 L41.587,19.654 L35.201,16.297 Z M59.537,16.297 L53.151,19.654 L54.37,12.543 L49.204,7.507 L56.344,6.47 L59.537,0 L62.73,6.47 L69.869,7.507 L64.703,12.543 L65.923,19.654 L59.537,16.297 Z M83.873,16.297 L77.487,19.654 L78.707,12.543 L73.54,7.507 L80.68,6.47 L83.873,0 L87.066,6.47 L94.206,7.507 L89.039,12.543 L90.259,19.654 L83.873,16.297 Z",
    id: "Shape",
    fill: "#FFCF00",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFCF00",
    strokeWidth: 0.885,
    points: "108.209 16.297 101.823 19.654 103.043 12.543 97.877 7.507 105.016 6.47 108.209 0 111.402 6.47 118.542 7.507 113.376 12.543 114.595 19.654"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(97.345000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "10.864 16.297 4.478 19.654 5.698 12.543 0.532 7.507 7.671 6.47 10.864 0 14.057 6.47 21.197 7.507 16.031 12.543 17.25 19.654"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__a"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFCF00",
    fillRule: "nonzero",
    mask: "url(#mask-2)",
    points: "-1.346 -7.822 16.906 -7.822 16.906 12.1928711 19.906 24.337 -1.346 24.337"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(19.000000, 30.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.654,0.42 L25.27,0.42 L25.27,23.018 L21.654,23.018 L21.654,0.42 Z M37.925,15.81 C37.925,19.268 35.017,19.543 34.152,19.543 C31.991,19.543 31.598,17.52 31.598,16.3 L31.598,7.651 L27.982,7.651 L27.982,16.281 C27.982,18.424 28.654,20.192 29.833,21.371 C30.874,22.413 32.435,22.983 34.125,22.983 C35.323,22.983 37.021,22.609 37.925,21.784 L37.925,23.018 L41.541,23.018 L41.541,7.65 L37.925,7.65 L37.925,15.808 L37.925,15.81 Z M48.772,2.228 L45.156,2.228 L45.156,7.651 L42.445,7.651 L42.445,11.267 L45.156,11.267 L45.156,23.018 L48.772,23.018 L48.772,11.267 L51.484,11.267 L51.484,7.651 L48.772,7.651 L48.772,2.228 Z M62.87,18.423 C62.083,19.131 61.044,19.523 59.903,19.523 C57.388,19.523 55.541,17.677 55.541,15.141 C55.541,12.606 57.329,10.837 59.903,10.837 C61.023,10.837 62.083,11.21 62.89,11.917 L63.439,12.39 L65.877,9.953 L65.267,9.403 C63.832,8.107 61.927,7.38 59.902,7.38 C55.382,7.38 52.1,10.641 52.1,15.122 C52.1,19.584 55.46,22.962 59.902,22.962 C61.965,22.962 63.89,22.235 65.306,20.919 L65.896,20.369 L63.42,17.933 L62.87,18.423 L62.87,18.423 Z M78.782,8.99 C77.741,7.95 76.52,7.38 74.83,7.38 C73.631,7.38 72.274,7.753 71.37,8.578 L71.37,0.42 L67.754,0.42 L67.754,23.018 L71.37,23.018 L71.37,14.553 C71.37,11.094 73.827,10.82 74.692,10.82 C76.853,10.82 76.793,12.843 76.793,14.062 L76.793,23.018 L80.409,23.018 L80.409,14.08 C80.409,11.938 79.962,10.17 78.782,8.99",
    id: "Shape",
    fill: "#00333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.783,12.567 C61.228,12.567 62.398,13.736 62.398,15.181 C62.398,16.625 61.228,17.795 59.783,17.795 C58.34,17.795 57.17,16.625 57.17,15.181 C57.171,13.736 58.34,12.567 59.783,12.567",
    id: "Path",
    fill: "#FF3D2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.593,17.342 C15.218,18.757 13.35,19.523 11.385,19.523 C7.357,19.523 4.428,16.36 4.428,12.017 C4.428,7.655 7.358,4.491 11.385,4.491 C13.331,4.491 15.178,5.257 16.574,6.653 L17.124,7.203 L19.54,4.786 L19.01,4.236 C17.006,2.171 14.294,1.052 11.385,1.052 C5.451,1.053 0.99,5.768 0.99,12.036 C0.99,18.285 5.47,22.982 11.385,22.982 C14.314,22.982 17.025,21.842 19.029,19.779 L19.56,19.229 L17.163,16.773 L16.593,17.343 L16.593,17.342 Z",
    id: "Path",
    fill: "#00333D"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClutch1);
export default __webpack_public_path__ + "static/media/Clutch_1.d461b712ab95b61d1bb1fb5380c450de.svg";
export { ForwardRef as ReactComponent };